import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, Form, Input, Icon, notification } from 'antd';
import { onChangeInput, onBlurInput, beforSubmit } from 'utils/Logics'
import { t } from 'utils/i18n';
import { updateMyInfomation } from 'apis/users';

const onHideModal = (setVisible) => () => setVisible(false)

const onOpenModal = setVisible => () => setVisible(true)

export default (props) => {
  const [visible, setVisible] = useState(false)
  const [message, setMessage] = useState("")
  const [position, setPosition] = useState()

  useEffect(() => {
    setPosition(props.position)
  }, [props.position])

  const onOk = async () => {
    const body = beforSubmit({
      position: {
        value: position,
        setMessage,
        title: "Position"
      }
    })
    if (!body) {
      return false
    }
    const response = await updateMyInfomation(body)
    if (response.status === 200) {
      notification.success({
        message: t("Success")
      })
      props.setPosition(body.position)
      setVisible(false)
      return
    }
    notification.error({
      message: t("Error"),
      description: t(response.data.message)
    })
  }

  return (
    <Fragment>
      <Button shape="circle" type="link" onClick={onOpenModal(setVisible)}>
        <Icon type="edit" />
      </Button>
      <Modal
        cancelText={t("Cancel")}
        title={t("Update position")}
        visible={visible}
        onCancel={onHideModal(setVisible)}
        onOk={onOk}
      >
        <Form>
          <Form.Item label={t("Position")} required help={message}>
            <Input
              value={position}
              onChange={onChangeInput(setPosition, setMessage)}
              onBlur={onBlurInput(position, setMessage, 'Position')}
              maxLength={100}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  )
}